import { styled, TextField } from '../../base-components';

export const StyledTextArea = styled(TextField)<{
    label: string;
}>(({ theme, label }) => ({
    '& .MuiInputBase-root': {
        borderRadius: '15px',
    },
    '& legend': !label && { display: 'none' },
    '& fieldset': !label && { top: 0 },
    '.Mui-error': {
        '&.MuiFormHelperText-root': {
            position: 'absolute',
            top: '100%',
            maxWidth: 'calc(100% - 40px)',
            marginTop: '0px',
            marginInlineStart: theme.spacing(1),
        },
    },
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(0.5),
    '&.MuiFormHelperText-root': {
        position: 'absolute',
        top: '100%',
    },
}));
